import { Button, makeStyles } from "@material-ui/core";
import { ReportProblem } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#F2F2F2",
    width:'100%',
    height:'100%'
  },
  btn: {
    marginTop: 30
  }
}));

const clickHandler = () => {
  //ログイン済み=>top page、未ログイン=>login page
  window.location.reload();
};

function ErrorPage() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ReportProblem fontSize="large" color="action"/>
      <h2>System Error.</h2>
      <Button className={classes.btn} variant="contained" color="primary" onClick={clickHandler}>TOP PAGE</Button>
    </div>
  );
}

export default ErrorPage;